import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { isNotEmpty } from '@hsp/utilities';

import { sharedABQueryKeys } from 'pages/audience/shared/utilities';
import { userService } from 'services';
import { IAudienceShop } from 'types/api/audience';
import { IResult } from 'types/api/common';

export const createShopQuery = (
  shopId: string
): UseQueryOptions<IResult<IAudienceShop> | undefined, unknown, IAudienceShop | undefined> => {
  return {
    enabled: isNotEmpty(shopId),
    queryFn: async () => await userService.getShop(shopId),
    queryKey: sharedABQueryKeys.shop.default(shopId),
    select: (data) => data?.dataContainer ?? undefined,
  };
};

export const useFetchShop = (shopId: string) => {
  return useQuery(createShopQuery(shopId));
};
